"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrailingStopV1Parameters = void 0;
const types_1 = require("../types");
const isTrailingStopV1Parameters = (x) => x.method === types_1.Method.TrailingStopV1;
exports.isTrailingStopV1Parameters = isTrailingStopV1Parameters;
